import { Component, OnInit, ViewChild } from '@angular/core';
import { SiteService, CommonService } from 'src/app/services/index';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { MeterModel } from 'src/app/models/index';
import * as moment from 'moment';
import { DataService } from 'src/app/services/data.service';
import { AlertService, Constants } from 'src/app/shared/index';
import { MatDialog } from '@angular/material';
import { WarningDialog } from 'src/app/shared/index';
@Component({
  selector: 'app-manage-solar-scheduler',
  templateUrl: './manage-solar-scheduler.component.html',
  styleUrls: ['./manage-solar-scheduler.component.scss']
})
export class ManageSolarSchedulerComponent implements OnInit {
  siteId: string;
  selectedSite: string;
  sites: any;
  exportDataForm: FormGroup;
  displayAllSiteID: boolean;
  date = new FormControl(new Date());
  startView = 'month';
  max = new Date();
  constructor(private siteService: SiteService, private commonService: CommonService,
    private dialog: MatDialog, private fb: FormBuilder, private alertService: AlertService) {
    this.exportDataForm = this.fb.group({
      siteCtr: ['', [Validators.required]],
      // dateCtr: []
    });
  }

  ngOnInit() {
    this.getSiteDetails();
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.displayAllSiteID = true;
    }
  }
  getSiteDetails() {
    this.siteService.getSiteDetails().subscribe(data => {
      this.sites = data;
    });
  }
  addMissingSolarValues() {
    const seft = this;
    const date = moment(this.date.value).format('YYYY-MM-DD');
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.selectedSite = this.siteId;
    }
    const params = {
      'siteID': this.selectedSite,
      'Date': date
    };

    this.siteService.insertSolarData(params).subscribe(function (data) {
      if (!seft.commonService.isNullOrUndefined(data)) {
        if(!seft.commonService.isNullOrUndefined(data.message)){
          seft.showMessage(data.message, 'Bosch-Ic-information');
        }
        else{
          seft.showMessage(data.data, 'Bosch-Ic-information');
        }
      }
    });
  }
  showMessage(msg, newIconClass) {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = msg;
    dialogRef.componentInstance.newIconClass = newIconClass;

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {

      }
    });
  }
}
